import { DailyReward } from "@/components/DailyReward";
import { Guide } from "@/components/Guide";
import GameHome from "@/pages/GameHome";
import { WalletShortcuts } from "@/components/WalletShortcuts";

export default function GamesHub() {
  return (
    <div className="pb-56" data-testid="games-hub">
      <Guide />
      <div className="mx-auto max-w-2xl px-4 pt-4"><WalletShortcuts /></div>
      <div className="mx-auto max-w-2xl px-4 pt-4"><DailyReward /></div>
      <GameHome />
    </div>
  );
}
